import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  approvalListing: { loading: false, data: [], error: null },
  approvalDetail: { loading: false, data: null, error: null },
  approvalPolicies: { loading: false, data: [], error: null },
  approvalAction: { loading: false, data: null, error: null },
};

const approvalsSlice = createSlice({
  name: "afmsApprovals",
  initialState,
  reducers: {
    // Listing
    approvalListingStart: (state) => {
      state.approvalListing.loading = true;
      state.approvalListing.error = null;
    },
    approvalListingSuccess: (state, action) => {
      state.approvalListing.loading = false;
      state.approvalListing.data = action.payload;
      state.approvalListing.error = null;
    },
    approvalListingFailure: (state, action) => {
      state.approvalListing.loading = false;
      state.approvalListing.error = action.payload;
    },
    approvalListingReset: (state) => {
      state.approvalListing = initialState.approvalListing;
    },

    // Detail
    approvalDetailStart: (state) => {
      state.approvalDetail.loading = true;
      state.approvalDetail.error = null;
    },
    approvalDetailSuccess: (state, action) => {
      state.approvalDetail.loading = false;
      state.approvalDetail.data = action.payload;
      state.approvalDetail.error = null;
    },
    approvalDetailFailure: (state, action) => {
      state.approvalDetail.loading = false;
      state.approvalDetail.error = action.payload;
    },

    // Policies
    approvalPoliciesStart: (state) => {
      state.approvalPolicies.loading = true;
      state.approvalPolicies.error = null;
    },
    approvalPoliciesSuccess: (state, action) => {
      state.approvalPolicies.loading = false;
      state.approvalPolicies.data = action.payload;
      state.approvalPolicies.error = null;
    },
    approvalPoliciesFailure: (state, action) => {
      state.approvalPolicies.loading = false;
      state.approvalPolicies.error = action.payload;
    },

    // Action (approve / return / reject)
    approvalActionStart: (state) => {
      state.approvalAction.loading = true;
      state.approvalAction.error = null;
      state.approvalAction.data = null;
    },
    approvalActionSuccess: (state, action) => {
      state.approvalAction.loading = false;
      state.approvalAction.data = action.payload;
      state.approvalAction.error = null;
    },
    approvalActionFailure: (state, action) => {
      state.approvalAction.loading = false;
      state.approvalAction.error = action.payload;
    },
    approvalActionReset: (state) => {
      state.approvalAction = initialState.approvalAction;
    },
  },
});

export const {
  approvalListingStart,
  approvalListingSuccess,
  approvalListingFailure,
  approvalListingReset,
  approvalDetailStart,
  approvalDetailSuccess,
  approvalDetailFailure,
  approvalPoliciesStart,
  approvalPoliciesSuccess,
  approvalPoliciesFailure,
  approvalActionStart,
  approvalActionSuccess,
  approvalActionFailure,
  approvalActionReset,
} = approvalsSlice.actions;

export default approvalsSlice.reducer;
